import { Button, Input, Modal, ModalDialog } from "@mui/joy";
import React, { useEffect, useState } from "react";
import ModalHeaderForMoney from "./modalheader";
import { postFetch } from "../../../../../fetch/fetch";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import koLocale from 'date-fns/locale/ko'
import { DateRange, StaticDateRangePicker } from "@mui/x-date-pickers-pro";
import { Box, FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import { calcRegisterFeeByLocation, makeGroupedFeeLines } from "../functions/newcalcregisterfuncs";
import { englishLocationToKorean, koreanLocationToEnglish } from "../../../../../data/locationFuntion";
import { Edit } from "@mui/icons-material";
import { set } from "lodash";
import { calcRefundAndCharge } from "../functions/calcregisterrefund";


const AddGoodModalForRefund = (props: any) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [value, setValue] = React.useState<DateRange<Date>>([null, null]);
    const [info, setInfo] = useState<any>();
    const [registerInfo, setRegisterInfo] = useState<any>();
    const [finalResult, setFinalResult] = useState<any>();
    const [postData, setPostData] = useState<any>([]);
    const [discount, setDiscount] = useState<number>(0);
    const [appliedDiscount, setAppliedDiscount] = useState<number>(0);

    const [modalOpen, setModalOpen] = useState<boolean>(false);

    const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(null);
    const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(null);
    const [selectedPrice, setSelectedPrice] = useState<number>(0);

    const [type, setType] = useState<string>("period")

    useEffect(() => {

        if(!props.open) {
            setAppliedDiscount(0);
            setDiscount(0);
        }

    }, [props.open]);

    useEffect(() => {

        if(!props.userId || !props.selectedStartDate || !props.selectedEndDate || !props.selectedPrice) {
            return;
        }

        console.log(props.userId, props.selectedStartDate, props.selectedEndDate, props.selectedPrice);

        setSelectedStartDate(props.selectedStartDate);
        setSelectedEndDate(props.selectedEndDate);
        setSelectedPrice(props.selectedPrice);

        //value 0은 아예 selectedStartDate로 고정
        //value 1은 상관하지마

        const newValue = value;

        newValue[0] = props.selectedStartDate;
        setValue(newValue);


    }, [props.userId, props.selectedStartDate, props.selectedEndDate, props.selectedPrice]);


    useEffect(() => {

        if(!props.userId || !selectedStartDate || !selectedEndDate || !selectedPrice) {
            return;
        }

        if(!value[0] || !value[1]) {
            return;
        }

        var result;

        var charge;

        if (type === "period") {
            result = calcRefundAndCharge({
                totalPaid: selectedPrice,
                periodStart: `${selectedStartDate.getFullYear()}-${(selectedStartDate.getMonth() + 1).toString().padStart(2, '0')}-${selectedStartDate.getDate().toString().padStart(2, '0')}`,
                periodEnd: `${selectedEndDate.getFullYear()}-${(selectedEndDate.getMonth() + 1).toString().padStart(2, '0')}-${selectedEndDate.getDate().toString().padStart(2, '0')}`,
                lastAttendDate: `${value[1].getFullYear()}-${(value[1].getMonth() + 1).toString().padStart(2, '0')}-${value[1].getDate().toString().padStart(2, '0')}`,
            });

            charge = result.charge;

        }

        if(type === "work"){
            result = calcRegisterFeeByLocation({
                registerPayInfo: props.registerPayInfo,
                selectedRange: [value[0], value[1]],
                appliedDiscount
            })

            const chargeLocations = result.result;

            if(props.selectedStudent && props.selectedStudent.location){
                const studentLocationInEnglish = koreanLocationToEnglish(props.selectedStudent.location);

                if(!studentLocationInEnglish){
                    charge = 0;
                    return;
                }

                if(chargeLocations[studentLocationInEnglish]){
                    charge = chargeLocations[studentLocationInEnglish];
                } else {
                    charge = 0;
                }
            } else {
                charge = 0;
            }

        }

        setFinalResult(charge);

    }, [props.userId, selectedStartDate, selectedEndDate, selectedPrice, value, type, appliedDiscount, props.selectedStudent]);

    const handleClose = () => {
        setModalOpen(false);
    }


    const submit = async () => {

        try {

            if(!finalResult || !value[0] || !value[1]){
                alert("등록 정보를 다시 확인해주세요.");
                return;
            }

            if(!props.userId){
                alert("사용자 정보가 올바르지 않습니다.");
                return;
            }

            if(!props.linkedOrderId){
                alert("연결된 주문 정보가 올바르지 않습니다.");
                return;
            }

            const data = {
                userId : props.userId,
                price : finalResult,
                startDateTime : value[0].getTime(),
                endDateTime : value[1].getTime(),
                linkedOrderId : props.linkedOrderId
            }

            setLoading(true);

            const result: any = await postFetch("/dashboard/payments/registergoodforrefund", {
                data
            });

            console.log(result);

            setLoading(false);

            if(result.message === "duplicateUserId"){
                alert("이미 날짜가 겹치는 상품이 존재합니다.");
                return;
            }

            if (result.message === "success") {

                props.notify();
                props.handleClose();
                props.setUpdate(Math.random());
            }

        } catch (e) {
            alert("에러가 발생했습니다.");
            console.log(e);
        }

    }


    useEffect(() => {
        if (!props.open) {
            setValue([null, null]);
            setFinalResult(undefined);
            setPostData([]);
            setRegisterInfo(undefined);
            setInfo(undefined);
            setLoading(false);
        }
    }, [props.open]);

    const formatKoreanDate = (date: Date) => {
        const days = ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"];

        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const dayOfWeek = days[date.getDay()];

        return `${year}년 ${month}월 ${day}일(${dayOfWeek})`;
    };


    useEffect(() => {

        if (!registerInfo) {
            return;
        }

        console.log(props.selectedStudentList);

    }, [registerInfo]);



    return (
        <Modal
            open={props.open}
            onClose={props.handleClose}
        >
            <ModalDialog>
                <div style={{
                    width: "620px",
                    overflowY: "auto",
                }}>
                    <div style={{
                        fontFamily: "Apple_B",
                        fontSize: "20px",
                        marginBottom: "18px"
                    }}>
                        환불 상품 추가하기
                    </div>
                    <div style={{
                        marginTop: "24px"
                    }}>
                        <div style={{
                            fontFamily: "Apple_SB",
                            marginBottom: "10px",
                            fontSize: "17px"
                        }}>
                            등록 날짜 설정
                        </div>
                        <div>
                            {
                                (selectedStartDate && selectedEndDate) ?
                                    <LocalizationProvider locale={koLocale} dateAdapter={AdapterDateFns}>
                                        <StaticDateRangePicker
                                            value={value}
                                            onChange={(value) => {

                                                const newValue = value;
                                                newValue[0] = selectedStartDate;

                                                setValue(newValue);
                                            }}
                                            displayStaticWrapperAs="desktop"
                                            renderInput={(startProps: any, endProps: any) => (
                                                <React.Fragment>
                                                    {/* <TextField {...startProps} /> */}
                                                    <Box sx={{ mx: 2 }}> to </Box>
                                                    {/* <TextField {...endProps} /> */}
                                                </React.Fragment>
                                            )}
                                            shouldDisableDate={(date: Date, position: string) => {

                                                date.setHours(0, 0, 0, 0);

                                                const selectedStartDateCopy = new Date(selectedStartDate);
                                                selectedStartDateCopy.setHours(0, 0, 0, 0);

                                                const selectedEndDateCopy = new Date(selectedEndDate);
                                                selectedEndDateCopy.setHours(0, 0, 0, 0);

                                                const dateTime = date.getTime();
                                                const startDateTime = selectedStartDateCopy.getTime();
                                                const endDateTime = selectedEndDateCopy.getTime();

                                                if(dateTime < startDateTime || dateTime > endDateTime){
                                                    return true;
                                                }

                                                return false;
                                            }}
                                        />
                                    </LocalizationProvider>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                    {
                        (value[0] && value[1]) ?
                            <>
                                <div style={{
                                    marginTop: "24px"
                                }}>
                                    <div style={{
                                        fontFamily: "Apple_SB",
                                        marginBottom: "10px",
                                        fontSize: "17px"
                                    }}>
                                        등록 예정 기간
                                    </div>
                                    <div>
                                        {formatKoreanDate(value[0])}
                                        {" ~ "}
                                        {formatKoreanDate(value[1])}
                                    </div>
                                </div>
                                <div style={{
                                    marginTop: "24px"
                                }}>
                                    <div style={{
                                        fontFamily: "Apple_SB",
                                        marginBottom: "3px",
                                        fontSize: "17px"
                                    }}>
                                        환불 재결제 수강료 계산 방식
                                    </div>
                                    <div>
                                        <RadioGroup
                                            value={type}
                                            onChange={(e) => {
                                                setType(e.target.value);
                                            }
                                            }
                                            row
                                        >
                                            <FormControlLabel value="period" control={<Radio />} label={
                                                <span style={{
                                                    fontFamily : "Apple_R"
                                                }}>
                                                    학원 환불법 기간 기준
                                                </span>
                                            } />
                                            <FormControlLabel value="work" control={<Radio />} label={
                                                <span style={{
                                                    fontFamily : "Apple_R"
                                                }}>
                                                    일할 분할 기준
                                                </span>
                                            } />
                                        </RadioGroup>
                                    </div>
                                </div>
                                <div style={{
                                    marginTop: "20px"
                                }}>
                                    <div style={{
                                        fontFamily: "Apple_SB",
                                        marginBottom: "10px",
                                        fontSize: "17px",
                                        display: "flex",
                                        alignItems: "center"
                                    }}>
                                        등록 예정 비용
                                        {
                                            type === "work" &&
                                            <span style={{
                                                display: "inline-flex", alignItems: "center"
                                            }}
                                                onClick={() => {
                                                    setModalOpen(true);
                                                }}
                                            >
                                                <Edit fontSize="small" style={{ marginLeft: "8px", cursor: "pointer" }} />
                                            </span>
                                        }
                                    </div>
                                    <div>
                                        {
                                            finalResult &&
                                            finalResult.toLocaleString() + "원"
                                        }
                                    </div>
                                </div>
                            </>
                            :
                            ""
                    }

                    <div style={{
                        marginTop: "32px"
                    }}>
                        <Button
                            fullWidth
                            variant="solid"
                            color="primary"
                            onClick={submit}
                            disabled={loading || !finalResult || !value[0] || !value[1]}
                            loading={loading}
                            size="lg"
                        >
                            상품 추가하기
                        </Button>
                    </div>
                </div>

                <Modal
                    open={modalOpen}
                    onClose={handleClose}
                >
                    <ModalDialog>
                        <div style={{
                            width: "300px"
                        }}>
                            <div style={{
                                fontFamily: "Apple_SB",
                                fontSize: "20px",
                                marginBottom: "12px"
                            }}>
                                할인률 설정
                            </div>
                            <div>
                                <Input
                                    fullWidth
                                    type="number"
                                    value={discount}
                                    onChange={(e) => {
                                        setDiscount(+e.target.value);
                                    }}
                                    endDecorator={<span>%</span>}
                                />
                            </div>
                            <div style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                marginTop: "24px"
                            }}>
                                <Button
                                    variant="solid"
                                    onClick={() => {
                                        setAppliedDiscount(discount);
                                        setModalOpen(false);
                                    }}
                                >
                                    적용시키기
                                </Button>
                            </div>
                        </div>
                    </ModalDialog>
                </Modal>


            </ModalDialog>
        </Modal>
    )
}

export default AddGoodModalForRefund;